import { useMutation } from "react-apollo-hooks";

export default function useApolloMutation(mutation, options) {
  return useMutation(mutation, options);
}
